import { Label } from "../../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";
import { PageComponent } from "../../../types/components";

interface DynamicSourceSelectorProps {
  pageComponents: PageComponent[];
  value?: string;
  onChange: (field: string | undefined) => void;
}

export function DynamicSourceSelector({
  pageComponents,
  value,
  onChange,
}: DynamicSourceSelectorProps) {
  // Só filtros "Tabela Vinculada" presentes NESTA página fazem sentido como
  // origem: activeFilters é um estado por página, então um filtro de outra
  // página nunca teria valor selecionado aqui.
  const linkedTableFilters = pageComponents.filter(
    (c) =>
      c.type === "filter" &&
      c.config?.optionsSource === "linkedTable" &&
      c.config?.field,
  );

  return (
    <div className="space-y-2">
      <Label>Filtro que define a origem</Label>
      <Select value={value || ""} onValueChange={(v) => onChange(v || undefined)}>
        <SelectTrigger>
          <SelectValue placeholder="Selecione um filtro de Tabela Vinculada" />
        </SelectTrigger>
        <SelectContent>
          {linkedTableFilters.length === 0 ? (
            <SelectItem value="_empty" disabled>
              Nenhum filtro "Tabela Vinculada" nesta página
            </SelectItem>
          ) : (
            linkedTableFilters.map((f) => (
              <SelectItem key={f.id} value={f.config.field}>
                {f.config?.title || `Filtro (${f.config.field})`}
              </SelectItem>
            ))
          )}
        </SelectContent>
      </Select>
      <p className="text-xs text-muted-foreground">
        A origem dos dados muda automaticamente conforme a opção selecionada
        nesse filtro (ex.: qual página está sendo visualizada).
      </p>
    </div>
  );
}
